/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PortfolioBasicLegalType = "HIDDEN" | "PX_PROVIDED" | "%future added value";
export type PortfolioStatus = "ACTIVE" | "INACTIVE" | "ONBOARDING" | "%future added value";
export type PortfolioVisibility = "HIDDEN" | "VISIBLE" | "%future added value";
export type ThemeAppearance = "DARK" | "LIGHT" | "%future added value";
export type ThemeAssetSize = "ORIGINAL" | "%future added value";
export type ThemeColour = "ACCENT_ASH" | "ACCENT_BLUE" | "ACCENT_GOLD" | "ACCENT_MONO" | "ACCENT_ORANGE" | "ACCENT_TEAL" | "ACCENT_VIOLET" | "BORDER" | "%future added value";
export type ThemeFont = "ALEO" | "INTER" | "PT_SERIF" | "%future added value";
export type PortfolioQueryRendererQueryVariables = {|
  domain: string
|};
export type PortfolioQueryRendererQueryResponse = {|
  +portfolio: ?{|
    +id: string,
    +legacyId: string,
    +status: PortfolioStatus,
    +title: string,
    +description: string,
    +email: ?string,
    +font: ThemeFont,
    +colour: ThemeColour,
    +appearance: ThemeAppearance,
    +deactivatedMessage: ?string,
    +socialMedia: ?{|
      +twitter: ?string,
      +instagram: ?string,
      +facebook: ?string,
    |},
    +location: ?{|
      +city: ?string,
      +country: ?string,
    |},
    +user: {|
      +username: string
    |},
    +termsOfUse: {|
      +type?: PortfolioBasicLegalType,
      +url?: string,
    |},
    +privacyPolicy: {|
      +type?: PortfolioBasicLegalType,
      +url?: string,
    |},
    +coverPhoto: {|
      +images?: $ReadOnlyArray<{|
        +legacyId: string,
        +url: string,
      |}>,
      +avatar?: {|
        +images: ?$ReadOnlyArray<?{|
          +url: string
        |}>
      |},
    |},
    +theme: {|
      +name: string,
      +description: string,
      +imageUrls: $ReadOnlyArray<{|
        +size: ?ThemeAssetSize,
        +url: string,
      |}>,
    |},
    +visibilityOptions: {|
      +location: PortfolioVisibility,
      +pxProfile: PortfolioVisibility,
      +instagram: PortfolioVisibility,
      +facebook: PortfolioVisibility,
      +twitter: PortfolioVisibility,
    |},
    +folders: $ReadOnlyArray<?{|
      +id: string,
      +name: string,
      +description: ?string,
      +coverPhoto: ?{|
        +legacyId: string,
        +name: ?string,
        +width: number,
        +height: number,
        +images: ?$ReadOnlyArray<?{|
          +jpegUrl: string,
          +webpUrl: string,
          +url: string,
        |}>,
      |},
      +photos: {|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +legacyId: string,
            +name: ?string,
            +description: ?string,
            +width: number,
            +height: number,
            +images: ?$ReadOnlyArray<?{|
              +size: number,
              +url: string,
              +id: string,
            |}>,
          |}
        |}>,
        +totalCount: ?number,
      |},
    |}>,
    +analyticsCode: ?string,
  |}
|};
export type PortfolioQueryRendererQuery = {|
  variables: PortfolioQueryRendererQueryVariables,
  response: PortfolioQueryRendererQueryResponse,
|};
*/


/*
query PortfolioQueryRendererQuery(
  $domain: String!
) {
  portfolio: getPortfolioByDomain(domain: $domain) {
    id
    legacyId
    status
    title
    description
    email
    font
    colour
    appearance
    deactivatedMessage
    socialMedia {
      twitter
      instagram
      facebook
    }
    location {
      city
      country
    }
    user {
      username
      id
    }
    termsOfUse {
      __typename
      ... on PortfolioBasicLegalSettings {
        type
      }
      ... on PortfolioCustomLegalSettings {
        url
      }
    }
    privacyPolicy {
      __typename
      ... on PortfolioBasicLegalSettings {
        type
      }
      ... on PortfolioCustomLegalSettings {
        url
      }
    }
    coverPhoto {
      __typename
      ... on PortfolioCoverImage {
        images {
          legacyId
          url
          id
        }
      }
      ... on PortfolioCoverAvatar {
        avatar {
          images(sizes: [COVER]) {
            url
            id
          }
          id
        }
      }
    }
    theme {
      name
      description
      imageUrls {
        size
        url
      }
      id
    }
    visibilityOptions {
      location
      pxProfile
      instagram
      facebook
      twitter
    }
    folders {
      id
      name
      description
      coverPhoto {
        legacyId
        name
        width
        height
        images(sizes: [21, 35]) {
          jpegUrl
          webpUrl
          url
          id
        }
        id
      }
      photos(first: 100) {
        edges {
          node {
            id
            legacyId
            name
            description
            width
            height
            images(sizes: [36, 35, 34, 33, 32]) {
              size
              url
              id
            }
          }
        }
        totalCount
      }
    }
    analyticsCode
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "domain"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "domain",
    "variableName": "domain"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "legacyId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "font",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "colour",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appearance",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deactivatedMessage",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "twitter",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "instagram",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "facebook",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "PortfolioSocialMedia",
  "kind": "LinkedField",
  "name": "socialMedia",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/)
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "PortfolioLocation",
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "city",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "country",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "type": "PortfolioBasicLegalSettings",
  "abstractKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v20 = [
  (v19/*: any*/)
],
v21 = {
  "kind": "InlineFragment",
  "selections": (v20/*: any*/),
  "type": "PortfolioCustomLegalSettings",
  "abstractKey": null
},
v22 = [
  (v18/*: any*/),
  (v21/*: any*/)
],
v23 = [
  {
    "kind": "Literal",
    "name": "sizes",
    "value": [
      "COVER"
    ]
  }
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "size",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "ThemeAsset",
  "kind": "LinkedField",
  "name": "imageUrls",
  "plural": true,
  "selections": [
    (v25/*: any*/),
    (v19/*: any*/)
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "PortfolioVisibilityOptions",
  "kind": "LinkedField",
  "name": "visibilityOptions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "location",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pxProfile",
      "storageKey": null
    },
    (v13/*: any*/),
    (v14/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v30 = [
  {
    "kind": "Literal",
    "name": "sizes",
    "value": [
      21,
      35
    ]
  }
],
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jpegUrl",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "webpUrl",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 100
    }
  ],
  "concreteType": "PhotoConnection",
  "kind": "LinkedField",
  "name": "photos",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PhotoEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Photo",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v3/*: any*/),
            (v24/*: any*/),
            (v6/*: any*/),
            (v28/*: any*/),
            (v29/*: any*/),
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "sizes",
                  "value": [
                    36,
                    35,
                    34,
                    33,
                    32
                  ]
                }
              ],
              "concreteType": "PhotoResizeImage",
              "kind": "LinkedField",
              "name": "images",
              "plural": true,
              "selections": [
                (v25/*: any*/),
                (v19/*: any*/),
                (v2/*: any*/)
              ],
              "storageKey": "images(sizes:[36,35,34,33,32])"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "storageKey": "photos(first:100)"
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "analyticsCode",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v36 = [
  (v35/*: any*/),
  (v18/*: any*/),
  (v21/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PortfolioQueryRendererQuery",
    "selections": [
      {
        "alias": "portfolio",
        "args": (v1/*: any*/),
        "concreteType": "Portfolio",
        "kind": "LinkedField",
        "name": "getPortfolioByDomain",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v17/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "termsOfUse",
            "plural": false,
            "selections": (v22/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "privacyPolicy",
            "plural": false,
            "selections": (v22/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "coverPhoto",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PortfolioCoverResizeImage",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "PortfolioCoverImage",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v23/*: any*/),
                        "concreteType": "UserAvatarResizeImage",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": true,
                        "selections": (v20/*: any*/),
                        "storageKey": "images(sizes:[\"COVER\"])"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "PortfolioCoverAvatar",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Theme",
            "kind": "LinkedField",
            "name": "theme",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              (v6/*: any*/),
              (v26/*: any*/)
            ],
            "storageKey": null
          },
          (v27/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Folder",
            "kind": "LinkedField",
            "name": "folders",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v24/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Photo",
                "kind": "LinkedField",
                "name": "coverPhoto",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v24/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": (v30/*: any*/),
                    "concreteType": "PhotoResizeImage",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": [
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v19/*: any*/)
                    ],
                    "storageKey": "images(sizes:[21,35])"
                  }
                ],
                "storageKey": null
              },
              (v33/*: any*/)
            ],
            "storageKey": null
          },
          (v34/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PortfolioQueryRendererQuery",
    "selections": [
      {
        "alias": "portfolio",
        "args": (v1/*: any*/),
        "concreteType": "Portfolio",
        "kind": "LinkedField",
        "name": "getPortfolioByDomain",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "termsOfUse",
            "plural": false,
            "selections": (v36/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "privacyPolicy",
            "plural": false,
            "selections": (v36/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "coverPhoto",
            "plural": false,
            "selections": [
              (v35/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PortfolioCoverResizeImage",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v19/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "PortfolioCoverImage",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v23/*: any*/),
                        "concreteType": "UserAvatarResizeImage",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": true,
                        "selections": [
                          (v19/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": "images(sizes:[\"COVER\"])"
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "PortfolioCoverAvatar",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Theme",
            "kind": "LinkedField",
            "name": "theme",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              (v6/*: any*/),
              (v26/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v27/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Folder",
            "kind": "LinkedField",
            "name": "folders",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v24/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Photo",
                "kind": "LinkedField",
                "name": "coverPhoto",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v24/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": (v30/*: any*/),
                    "concreteType": "PhotoResizeImage",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": [
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v19/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": "images(sizes:[21,35])"
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v33/*: any*/)
            ],
            "storageKey": null
          },
          (v34/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e651e1db37a404208b1978a4925d2a7d",
    "id": null,
    "metadata": {},
    "name": "PortfolioQueryRendererQuery",
    "operationKind": "query",
    "text": "query PortfolioQueryRendererQuery(\n  $domain: String!\n) {\n  portfolio: getPortfolioByDomain(domain: $domain) {\n    id\n    legacyId\n    status\n    title\n    description\n    email\n    font\n    colour\n    appearance\n    deactivatedMessage\n    socialMedia {\n      twitter\n      instagram\n      facebook\n    }\n    location {\n      city\n      country\n    }\n    user {\n      username\n      id\n    }\n    termsOfUse {\n      __typename\n      ... on PortfolioBasicLegalSettings {\n        type\n      }\n      ... on PortfolioCustomLegalSettings {\n        url\n      }\n    }\n    privacyPolicy {\n      __typename\n      ... on PortfolioBasicLegalSettings {\n        type\n      }\n      ... on PortfolioCustomLegalSettings {\n        url\n      }\n    }\n    coverPhoto {\n      __typename\n      ... on PortfolioCoverImage {\n        images {\n          legacyId\n          url\n          id\n        }\n      }\n      ... on PortfolioCoverAvatar {\n        avatar {\n          images(sizes: [COVER]) {\n            url\n            id\n          }\n          id\n        }\n      }\n    }\n    theme {\n      name\n      description\n      imageUrls {\n        size\n        url\n      }\n      id\n    }\n    visibilityOptions {\n      location\n      pxProfile\n      instagram\n      facebook\n      twitter\n    }\n    folders {\n      id\n      name\n      description\n      coverPhoto {\n        legacyId\n        name\n        width\n        height\n        images(sizes: [21, 35]) {\n          jpegUrl\n          webpUrl\n          url\n          id\n        }\n        id\n      }\n      photos(first: 100) {\n        edges {\n          node {\n            id\n            legacyId\n            name\n            description\n            width\n            height\n            images(sizes: [36, 35, 34, 33, 32]) {\n              size\n              url\n              id\n            }\n          }\n        }\n        totalCount\n      }\n    }\n    analyticsCode\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c7dbec66aacfbea45601d5fcd2c3992e';

module.exports = node;
